<template>
    <v-app class="homepage">
        <div class="homepage__container homepage__white">
            <v-container class="main-block homepage__container-faq homepage__container-faq-osago-and-agent">
                <v-layout wrap  class="homepage__container-faq-osago-and-agent__header">
                    <v-flex xs8>
                        <h1>Вопросы</h1>
                    </v-flex>
                    <v-flex xs4 class="header-right-link-block">
                        <a class="green-underline-link" @click="openFeedback">
                            Задать вопрос
                        </a>
                    </v-flex>
                </v-layout>
                <home-questions
                    :faq="faq"
                />
            </v-container>
        </div>
        <div class="homepage__container homepage__white homepage__mobile-grey">
            <v-container class="homepage__container-faq homepage__container-faq__any-question-inner homepage__container-faq-osago-and-agent">
                <v-flex wrap row class="homepage__container-faq__any-question">
                    <h3>Не нашли, что искали?</h3>
                    <v-flex class="homepage__container-faq__any-question__text">
                        <p>По любым вопросам пишите на <a href="mailto:mail@getpolis.ru">mail@getpolis.ru</a>, или через форму.<br>Мы вместе сможем сделать проект лучше.</p>
                        <a class="black-button" @click="openFeedback">Задать вопрос</a>
                    </v-flex>
                </v-flex>
            </v-container>
        </div>
        <homepage-feedback
            :dialog="dialog"
            @closeFeedback="closeFeedback"
        />
    </v-app>
</template>

<script>
export default {
    data: () => ({
        dialog: false,
        faq: [
            {
                question: 'Как купить страховой полис?',
                answer: 'Заполните анкету с необходимыми данными. Сервис getpolis.ru запросит расчет стоимости полиса в нескольких страховых компаниях. Выберите понравившееся предложение и оплатите полис, оплата происходит непосредственно в страховую компанию. После оплаты страховая компания отправит полис на электронную почту, указанную при заполнении анкеты. Также полис будет доступен в личном кабинете на сайте <a href="https://getpolis.ru">getpolis.ru</a>',
            },
            {
                question: 'На вашем сайте цены за страховку ниже, чем на сайтах страховых компаний?',
                answer: 'Стоимость полиса на нашем сайте и в страховой компании одинакова. При этом в разных компаниях цена полиса может отличаться. Мы предложим полисы сразу нескольких компаний, чтобы Вы могли выбрать самый подходящий вариант.',
            },
            {
                question: 'Почему купить полис у вас выгоднее, чем в страховой компании?',
                answer: 'Стоимость полиса в разных страховых компаниях может отличаться, воспользовавшись нашим сервисом Вы сэкономите время и сразу получите предложения нескольких страховых компаний, среди которых выберите самое выгодное. Оплата производится напрямую в страховую компанию по цене страховой компании. Кроме того, полис Вы получите на электронную почту, без посещения страховой компании.',
            },
            {
                question: 'Можно ли доверять вашей компании и почему?',
                answer: 'Мы сотрудничаем с известными и надежными страховыми компаниями. Между нами заключены официальные агентские договоры, и при обращении в страховые компании Вам подтвердят статус нашего официального партнерства. К тому же при оплате полиса, платеж производится непосредственно в страховую компанию. Также, подтвердить действительность приобретенного через наш сервис полиса можно <a href="https://dkbm-web.autoins.ru/dkbm-web-1.0/policyInfo.htm" target="_blank">на портале РСА (Российского союза автостраховщиков)</a>, либо в страховой компании, полис которой вы приобретете.',
            },
            {
                question: 'В чем разница между электронным и бумажным полисом?',
                answer: 'Юридически электронный и бумажный полис - это два равноценных документа, имеющих одинаковую силу. Однако электронный полис проще и быстрее купить, и удобнее использовать. Например, его невозможно потерять, он высылается Вам на электронную почту, хранится в личном кабинете на нашем сайте и в страховой компании. Как следствие, уже в январе 2019 года, по данным Российского союза автостраховщиков, электронные полисы стали популярнее бумажных.',
            },
            {
                question: 'Как проверить действительность электронного полиса?',
                answer: 'Действительность электронного полиса проверяется на сайте Российского союза автостраховщиков по этой <a href="https://dkbm-web.autoins.ru/dkbm-web-1.0/policyInfo.htm" target="_blank">ссылке</a>, либо в страховой компании. Электронный полис имеет такую же юридическую силу, как и бумажный, и заверен электронной подписью и печатью страховой компании.',
            },
            {
                question: 'Как обеспечивается безопасность платежей?',
                answer: 'Для обеспечения безопасности и во избежание лишнего посредничества платеж производится через платежную систему страховой компании и поступает непосредственно в страховую компанию, которую Вы выбрали.',
            },
            {
                question: 'Где найти оформленные мной полисы?',
                answer: 'Оформленные Вами страховые полисы хранятся в личном кабинете, а также высылаются на электронную почту, которую Вы указали при оформлении полиса.',
            },
            {
                question: 'Что делать, если я поменял права?',
                answer: 'В этом случае нужно внести соответствующие изменения в страховой полис. Для этого звоните нам по телефону <a href="tel:88002010643">8 800 201 06 43</a> или пишите на почту <a href="mailto:mail@getpolis.ru">mail@getpolis.ru</a>, письмо можно отправить через форму <a class="open-feedback-form">«Задать вопрос»</a>. Наши специалисты Вас проконсультируют.',
            },
            {
                question: 'Как внести изменения в оформленный полис или исправить неверно указанные данные?',
                answer: 'Если Вам необходимо внести изменения в полис, звоните нам по телефону <a href="tel:88002010643">8 800 201 06 43</a> или пишите на почту <a href="mailto:mail@getpolis.ru">mail@getpolis.ru</a>, письмо можно отправить через форму <a class="open-feedback-form">«Задать вопрос»</a>. Наши специалисты Вас проконсультируют.',
            },
            {
                question: 'Куда обращаться, если произошло ДТП?',
                answer: 'Если у Вас произошло ДТП, звоните по номеру <a href="tel:88002010643">8 800 201 06 43</a>, наши специалисты проконсультируют Вас о дальнейших действиях. <br>Также Вы можете обратиться в страховую компанию, ее номер указан на полисе ОСАГО.',
            },
            {
                question: 'Что делать, если я потерял полис ОСАГО?',
                answer: 'Зайдите в свой личный кабинет на нашем сайте, скачайте из него свой полис и распечатайте.',
            },
        ]
    }),

    mounted() {
        this.initFeedbackLinks()
    },

    methods: {
        openFeedback() {
            this.dialog = true
        },
        closeFeedback() {
            this.dialog = false
        },
        initFeedbackLinks() {
            let links = [...document.getElementsByClassName('open-feedback-form')]
            links.forEach((link) => {
                link.addEventListener('click', (e) => {
                    this.openFeedback()
                })
            })

        }
    }
}
</script>
</script>



// WEBPACK FOOTER //
// resources/js/components/pages/OsagoFaq.vue